var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuburbanAreas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0L5 4.58V3H3V6.11L0 8.4L1.21 9.99L3 8.62V18H19V8.62L20.79 9.98L22 8.4L11 0ZM17 16H12V12H10V16H5V7.1L11 2.52L17 7.1V16Z",
    fill: "#526181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuburbanAreas);
export default __webpack_public_path__ + "static/media/suburban-areas.212105f20d8d33af266d571a839604f7.svg";
export { ForwardRef as ReactComponent };